<div class="size-setting-container">
    <div class="row mb-3">
        <label>{{'MENU_FILE_PROPERTIES_SIZING_SETTINGS_TITLE' | translate}}</label>
    </div>
    <fieldset [formGroup]="sizingSettingsForm">
        <legend>{{'MENU_FILE_PROPERTIES_SIZING_SETTINGS_AUTOMATION_CONTROLLER_SIZING' | translate}}</legend>
        <div class="row row-height">
            <div class="col-sm-2 mt-2"><label>{{'MENU_FILE_PROPERTIES_SIZING_SETTINGS_ALN_NETWORK_TYPE' | translate}}</label></div>
            <div class="col-sm-3 mt-2">
                <mat-form-field class="full-width" appearance="outline" class="col-sm-12">
                    <mat-select formControlName="alnNetworkType">
                        <mat-option *ngFor="let size of ['Small', 'Medium', 'Large']" [value]="size">
                            {{size}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-4">
                <mat-checkbox color="primary" formControlName="useHandOffAuto">{{'MENU_FILE_PROPERTIES_SIZING_SETTINGS_USE_HAND_OFF_AUTO' | translate}}</mat-checkbox>
            </div>
        </div>
        <div class="row row-height">
            <div class="col-sm-2 mt-2"><label>{{'MENU_FILE_PROPERTIES_SIZING_SETTINGS_FLN_NETWORK_TYPE' | translate}}</label></div>
            <div class="col-sm-3 mt-2">
                <mat-form-field class="full-width" appearance="outline" class="col-sm-12">
                    <mat-select formControlName="flnNetworkType">
                        <mat-option *ngFor="let size of ['Small', 'Medium', 'Large']" [value]="size">
                            {{size}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-sm-4">
                <mat-checkbox color="primary" formControlName="useOperatorDisplay">{{'MENU_FILE_PROPERTIES_SIZING_SETTINGS_USE_OPERATOR_DISPLAY' | translate}}</mat-checkbox>
            </div>
        </div>
        <div class="row row-height col-sm-4">
            <div class="col-sm-6 mt-2"><label>{{'MENU_FILE_PROPERTIES_SIZING_SETTINGS_SPARE_CAPACITY' | translate}}</label></div>
            <div class="col-sm-4 mt-2 ms-1">
                <mat-form-field class="full-width" appearance="outline" class="col-sm-12">
                    <input matInput type="text" mask="percent" suffix="%" formControlName="spareCapacity">
                </mat-form-field>
            </div>
        </div>
    </fieldset>
</div>